import React from "react";
import { StyledDiv } from './Section4.style'
import { Card } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import v1 from '../../assets/images/v1.svg'
import v2 from '../../assets/images/v2.svg'
import v3 from '../../assets/images/v3.svg'
import v4 from '../../assets/images/v4.svg'
import v5 from '../../assets/images/v5.svg'
import v6 from '../../assets/images/v7.svg'
import v9 from '../../assets/images/v9.svg'
 
const healthcareFeatures = [
  {
    title: 'Appointments',
    icon: v1,
    description: `myindici's booking interface has been designed to ensure a quick, hassle-free experience. Easily book appointments with your provider or other specialists.`,
  },
  {
    title: 'Repeat Prescriptions',
    icon: v2,
    description: `Requesting repeat prescriptions couldn't be easier. You can pick them up from your practice or have them sent to your local pharmacy for true convenience.`,
  },
  {
    title: 'Messaging',
    icon: v3,
    description: `Avail of myindici's secure messaging channel to interact directly with your provider or care team.`,
  },
  {
    title: 'Virtual Consults',
    icon: v4,
    description: `Save time and stress by booking and attending virtual consults through myindici.`,
  },
  {
    title: 'Instant Access',
    icon: v6,
    description: `View your health information wherever you are. Easily access your diagnoses, vital readings, immunisation lists and more.`,
  },
  {
    title: 'Online Payment',
    icon: v5,
    description: `Simplified billing means you can take care of your medical payments with just a couple of clicks.`,
  },
  {
    title: 'Resources You can Trust',
    icon: v6,
    description: `Enjoy access to information you can have
    confidence in, with a library of resources selected for you by your practice.`,
  },
  {
    title: '',
    icon: v9,
    description: `Click here to check out our full Features Suite`,
  }
];
interface Section4Props {
  handleMenuItemClick: (menuItemKey?: any) => void;
}
const Section4: React.FC<Section4Props> = ({ handleMenuItemClick }) => {
  const history = useHistory();
  const handleFeatureClick = (menuItem:any) =>
    {
        history.push('/features');
        window.scrollTo(0, 0);
        handleMenuItemClick(menuItem);
    };
  return (
    <StyledDiv>
    <div className="container pt-5 pb-5 modrenHealth" >
      <div className="row ">
        <div className="col-md-12">
          <div style={{ textAlign: "center" }}>
            <h2 className="myindici-heading2 mb-2">Modern Healthcare for Patients</h2>
          </div>
        </div>
        <div className="col-md-12 mb-1 text-center">
          <div className="row">
            <div className="col-lg-12">
              <p className="para p-3">
              myindici harnesses the power and comfort of modern, cloud-based
              technologies to provide you with a seamless experience every time
              you need to access your healthcare.
            </p>
            </div>
          </div>
        </div>
      </div>
      <div className="row mt-2">
        <div className="col-md-12">
          {/* <CardHealthCare /> */}
          <div className='row'>
     {healthcareFeatures.map((feature, index) => (
  <div className="col-lg-3 col-md-4 col-sm-6" key={index}>
    <Card
      onClick={() => handleFeatureClick('Features')}
      className={`carditem ${index === healthcareFeatures.length - 1 ? 'last-item' : ''}`}
    >
      <Card.Body>
        <img src={feature.icon} alt="images" style={{ width: '35px', height: '35px' }}
          className={`${index === healthcareFeatures.length - 1 ? 'last-icon' : ''}`}  />
        <Card.Title className='card-title'>{feature.title}</Card.Title>
        <Card.Text className='card-title2'>{feature.description}</Card.Text>
      </Card.Body>
    </Card>
  </div>
))}
    </div>
        </div>
      </div>
    </div>
    </StyledDiv>
  );
};
 
export default Section4;
 